<template>
    <div>
        <router-view></router-view>
    </div>
</template>

<script>
    export default {
        name:'achievement'
    }
</script>

<style lang="scss" scoped>

</style>